import EditCustomerContainer from './EditCustomerContainer';
import ViewCustomerContainer from './ViewCustomerContainer';
import AddCustomerContainer from './AddCustomerContainer';
import CustomerContainer from './CustomerContainer';
import DeleteCustomerContainer from './DeleteCustomerContainer';

export {
	AddCustomerContainer,
	CustomerContainer,
	EditCustomerContainer,
	ViewCustomerContainer,
	DeleteCustomerContainer,
};
